import { Navigate, Route, Routes } from "react-router-dom";
import React, { Suspense, useEffect, useState } from "react";
import PrivateRoute from "../components/PrivateRoute/PrivateRoute";
import { useStore } from "../hooks";
import Loading from "../components/Loading/Loading";
import returnRoutes from "../utils/returnRoleRoutes";
import { observer } from "mobx-react-lite";
import { CopilotKit } from "@copilotkit/react-core";
import { CopilotPopup } from "@copilotkit/react-ui";
import { config } from "../config";

export const Router = observer(() => {
  const { auth } = useStore();
  const [theme] = useState(localStorage.theme);
  const colorTheme = theme === "dark" ? "light" : "dark";
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove(colorTheme);
    root.classList.add(theme);
    localStorage.setItem("theme", theme);
  }, [theme, colorTheme]);

  return (
    <CopilotKit runtimeUrl={`${config.API_URL}/copilotkit`}>
      <div>
        <Routes>
          {returnRoutes(auth?.user?.roles).map((route, i) => {
            return (
              <Route
                key={i}
                path={route?.path}
                element={
                  <Suspense fallback={<Loading />}>
                    {route?.element ? (
                      route?.isPrivate ? (
                        <PrivateRoute>
                          <route.element
                            routes={route?.subRoutes}
                            subRoutes={route?.subRoutes}
                          />
                        </PrivateRoute>
                      ) : (
                        <route.element subRoutes={route?.subRoutes} />
                      )
                    ) : null}
                  </Suspense>
                }
              >
                {route?.subRoutes?.map((subRoute, index) => {
                  if (subRoute?.isNavigate) {
                    return (
                      <Route
                        key={index}
                        path={subRoute?.path}
                        element={<Navigate to={subRoute.to} />}
                      />
                    );
                  } else
                    return (
                      <Route
                        key={index}
                        path={subRoute.path}
                        element={<subRoute.element />}
                      >
                        {subRoute?.subRoutes?.map((subRoute, idx) => {
                          return (
                            <Route
                              key={index}
                              path={subRoute.path}
                              element={<subRoute.element />}
                            />
                          );
                        })}
                      </Route>
                    );
                })}
              </Route>
            );
          })}
          <Route
            path={"*"}
            element={
              <Navigate
                to={
                  auth.isLogged && auth.user.roles.includes("storage:user")
                    ? "/storage"
                    : auth.isLogged && auth.user.roles.includes("delivery:user")
                    ? "/delivery-tasks"
                    : auth.isLogged
                    ? "/"
                    : "/auth/login"
                }
              />
            }
          />
        </Routes>
        {auth?.user?.roles?.includes("all:access") && (
          <CopilotPopup
            defaultOpen={false}
            instructions={
              "You are assisting the user as best as you can. Answer in the best way possible given the data you have."
            }
            labels={{
              title: "SZONE",
              initial:
                "Merhaba, Szone'a hoşgeldiniz. Size nasıl yardımcı olabilirim?",
            }}
          />
        )}
      </div>
    </CopilotKit>
  );
});
